import { render, staticRenderFns } from "./TermSignature.vue?vue&type=template&id=2db3ed4b"
import script from "./TermSignature.vue?vue&type=script&lang=js"
export * from "./TermSignature.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports